import { Block, NavList, Paragraph } from '@deckee/deck-hand';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
import CheckSwitch from '../../../shared/_deprecated/components/CheckSwitch/CheckSwitch';
import HeaderBar from '../../../layouts/components/HeaderBar/HeaderBar';
import HeaderBarButton from '../../../layouts/components/HeaderBarButton/HeaderBarButton';
import { back, close } from '../../../shared/vector-images';

const MapSettingsMarkerGroupContainerView = (props) => {
  const { toggleSelectedLayerType, selectedLayerTypes, mapLayerMarkerTypes } =
    props;

  const history = useHistory();

  const selectedLayerTypesSet = new Set(selectedLayerTypes);

  // Sort mapLayerMarkerTypes alphabetically
  const sortedMapLayerMarkerTypes =
    mapLayerMarkerTypes &&
    mapLayerMarkerTypes.sort((a, b) =>
      a.displayName > b.displayName ? 1 : -1,
    );

  return (
    <SheetLayout
      heading="Map settings"
      renderHeaderBar={(heading) => (
        <HeaderBar
          centerNode={heading}
          leftNode={[
            <HeaderBarButton
              key="button-back"
              ariaLabel="back"
              icon={back()}
              onClick={history.goBack}
            />,
          ]}
          rightNode={[
            <HeaderBarButton
              key="button-close"
              ariaLabel="close"
              icon={close()}
              onClick={() => history.push('/maps/settings/map')}
            />,
          ]}
        />
      )}
      showMenuBar={false}
      showMapOverlay
    >
      <SheetBody>
        <NavList>
          {sortedMapLayerMarkerTypes &&
            sortedMapLayerMarkerTypes.map((mapLayerMarkerType) => {
              const { displayName, menuIconNode, layerName } =
                mapLayerMarkerType;

              return (
                <NavList.Item
                  key={`menu-item_${displayName}`}
                  onClick={() => toggleSelectedLayerType(layerName)}
                >
                  <Block>{menuIconNode}</Block>
                  <Paragraph>{displayName}</Paragraph>

                  <Block display="flex" ml="auto">
                    <CheckSwitch
                      action={() => toggleSelectedLayerType(layerName)}
                      isActive={selectedLayerTypesSet.has(layerName)}
                    />
                  </Block>
                </NavList.Item>
              );
            })}
        </NavList>
      </SheetBody>
    </SheetLayout>
  );
};

MapSettingsMarkerGroupContainerView.propTypes = {
  toggleSelectedLayerType: PropTypes.func.isRequired,

  selectedLayerTypes: PropTypes.arrayOf(PropTypes.string),
  mapLayerMarkerTypes: PropTypes.arrayOf(PropTypes.shape()),
};

MapSettingsMarkerGroupContainerView.defaultProps = {
  selectedLayerTypes: [],
  mapLayerMarkerTypes: [],
};

export default MapSettingsMarkerGroupContainerView;
